<template>
  <div
    class="elementgroup"
    :class="className"
    @click="$emit('click', $event)"
  >
    <div
      v-if="!score && icon !== null"
      class="icon-container"
    >
      <icon
        :icon="icon"
        size="m"
      />
    </div>
    <div
      v-if="score"
      class="icon-container"
    >
      <div
        class="fake-icon"
        :class="{ 'high-score': score >= 8, 'low-score': score <= 5 }"
      >
        {{ score }}
      </div>
    </div>

    <div class="elementvalue">
      <span class="title">
        <slot name="title" />
      </span>
      <span>
        <slot name="subtitle" />
      </span>
    </div>
  </div>
</template>
<script>
import Icon from '../icon/Icon.vue';

export default {
    components: {
        Icon,
    },
    props: [
        'icon',
        'className',
        'score',
    ],
};
</script>
<style lang="scss">
  @use 'assets/scss/_variables/colors';

  .elementgroup {
    .fake-icon {
      color: colors.$link-base-default;
      font-size: font('header');

      &.high-score {
        color: #289468;
      }

      &.low-score {
        color: #69858e;
      }
    }

    &.nl .icon-element {
      background-color: #289468;
    }

    &.gray .icon-element {
      background-color: #69858e;
    }
  }
</style>
